
import { QuestionBase, QuestionBaseParams, QuestionUITypes, QuestionVisiblityOperation, QuestionVisiblityOperators, QuestionRequestTypes } from './question-base';
import { ValidatorFn, Validator, Validators, AbstractControl } from '@angular/forms';

export interface DrowdownQuestionBaseParams<T> extends QuestionBaseParams<T>{
  options: Array<{value: string, label: string}>
}

export class DropdownQuestion extends QuestionBase<string> {
  public questionType: QuestionUITypes = QuestionUITypes.DROPDOWN;
  public options: Array<{value: string, label: string}>;

  constructor(questionParams: DrowdownQuestionBaseParams<string> ) {
    super(questionParams);
    this.options = questionParams['options'];
  }

  public getValidators() : Array<ValidatorFn> {
    let validators : Array<ValidatorFn> = super.getValidators();
    switch( this.key ){
      case 'kvArt':
      
        validators.push( ( control : AbstractControl ) => {
          if( control.value === 'false' ){
            return { 'error' : 'Select this plise' };
          }else{
            return null;
          }
        });
      break;
    }

    return validators;
  }

  public getValueForRequest() : string | number {
    if( this.requestType === QuestionRequestTypes.STRING ){
      return this.getAvailableValue();
    }else if( this.requestType === QuestionRequestTypes.INTEGER ){
      return parseInt( this.getAvailableValue() );
    }else{
      console.error( 'bad here' );
    }
  }

  protected isVisible(operation : QuestionVisiblityOperation) : boolean{
    let result : boolean;

    if( this.requestType === QuestionRequestTypes.INTEGER ){
      let ourValue : number = parseInt( this.getLiveValue() );
      let operationValue : number = parseInt( operation.value );

      switch(operation.operator){
        case QuestionVisiblityOperators.EQUAL:
          result = ourValue === operationValue;
        break;
  
        case QuestionVisiblityOperators.LESS_THAN:
          result = ourValue < operationValue;
        break;
  
        case QuestionVisiblityOperators.GREATER_THAN:
          result = ourValue > operationValue;
        break;
      }
    }else{
      console.error( 'here' );
    }

    return result;
  }
}


// WEBPACK FOOTER //
// ./src/app/question-dropdown.ts